
<template>
  <GroupReservationHead
    v-if="order && order.reservation"
    :reservation="order.reservation"
    :selectedGroup="order.selectedGroup"
    :order="order"
  />

  <!-- reuse AuthCode for the login / verification UI -->
  <AuthCode
    :title="title"
    :subtitle="subtitle"
    :agreements="agreements"
    :onNext="onSuccessFromAuthCode"
    :order="order"
    :onCancel="onCancel"
  />

  

    <NextButton v-if="order" :onNext="onSuccess" :onPrev="onCancel" :canProceed="canProceed" />
    <Summary v-if="order" :order="order" class="lg:hidden" />

</template>

<script>
import AuthCode from './AuthCode.vue';
import NextButton from './NextButton.vue';
import Summary from './Summary.vue';
import GroupReservationHead from './GroupReservationHead.vue';
import rpAPI from '@shared/service/rpAPI.js';
import Globals from '@shared/model/Globals.js';

export default {
  name: 'AuthUser',
  components: {
    AuthCode,
    NextButton,
    Summary,
    GroupReservationHead
  },
  props: {
    title: {
      type: String,
      default: 'Potwierdź dane kontaktowe'
    },
    subtitle: {
      type: String,
      default: 'Podaj adres e-mail. Wyślemy na niego kod, aby potwierdzić Twoją tożsamość i dokończyć proces.'
    },
    agreements: {
      type: Array,
      default: () => []
    },
    onNext: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    order: {
      type: Object,
      required: false,
      default: null
    }
  },

  setup(props) {
    // If user already logged in, ensure order has customer set
    if (rpAPI.isLoggedIn() && props.order && typeof props.order.setCustomer === 'function') {
      props.order.setCustomer(rpAPI.user);
    }
  },
  computed: {
    user() {
      return rpAPI.user;
    },
    acronym() {
      return this.user.initials();
    },
    isTemporaryEmail() {
      return this.user.isTemporaryEmail();
    },
    userName() {
      return this.user.displayName();
    },
    userContact() {
      if (this.user && this.user.email && !this.isTemporaryEmail) {
        return this.user.email;
      } else if (this.user && this.user.phone) {
        return this.formatPhone(this.user.phone);
      }
      return '';
    },
    roundedClass() {
      return Globals.getRoundedClass();
    }
  },
  methods: {
    formatPhone(phone) {
      if (!phone) return '';
      const sanitizedPhone = phone.replace(/\D/g, '');
      if (sanitizedPhone.length === 9) {
        return `+48 ${sanitizedPhone.slice(0, 3)} ${sanitizedPhone.slice(3, 6)} ${sanitizedPhone.slice(6)}`;
      } else if (sanitizedPhone.length > 9) {
        return `+${sanitizedPhone.slice(0, sanitizedPhone.length - 9)} ${sanitizedPhone.slice(-9, -6)} ${sanitizedPhone.slice(-6, -3)} ${sanitizedPhone.slice(-3)}`;
      }
      return phone;
    },
    isLoggedIn() {
      return rpAPI.isLoggedIn() && this.user && this.user.isInitialized && this.user.isInitialized();
    },
    logout() {
      rpAPI.logout();
      if (typeof this.onCancel === 'function') this.onCancel();
    },

    handleEligible(val) {
      this.eligible = !!val;
    },

    canProceed() {
      return (this.isLoggedIn() )
    },

    onSuccess() {
      // Called by NextButton when user is already logged in
      if (this.order && typeof this.order.setCustomer === 'function') {
        this.order.setCustomer(rpAPI.user);
      }
      if (typeof this.onNext === 'function') this.onNext();
    },
    // Handler to pass into AuthCode (AuthCode will call this after successful verification)
    onSuccessFromAuthCode() {
      if (this.order && typeof this.order.setCustomer === 'function') {
        this.order.setCustomer(rpAPI.user);
      }
    }
  }
};
</script>
